var _path, _path2, _circle, _path3, _path4, _circle2, _path5, _path6, _circle3, _rect, _path7, _rect2, _path8, _rect3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceStrengthTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 144,
    viewBox: "0 0 294 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.154 65.2314L31.1739 50.9029C29.5451 45.0391 32.9797 38.9968 39.0151 38.2146C42.0156 37.8257 45.4362 37.5391 49.0002 37.5391C52.5641 37.5391 55.9848 37.8257 58.9853 38.2146C65.0207 38.9968 68.4553 45.0391 66.8265 50.9029L62.8463 65.2314",
    stroke: "#EA4C54",
    strokeWidth: 8.30769
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 54.1543C63.5293 54.1543 75.3076 65.9326 75.3076 80.4619C75.3076 88.2213 71.9476 95.1952 66.6039 100.01C65.6882 100.835 64.4773 101.231 63.2447 101.231H34.7553C33.5227 101.231 32.3118 100.835 31.3961 100.01C26.0524 95.1952 22.6924 88.2213 22.6924 80.4619C22.6924 65.9326 34.4707 54.1543 49 54.1543Z",
    fill: "#EA4C54"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.9998,
    cy: 79.0769,
    r: 11.0769,
    fill: "#DA4149"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.154 65.2314L127.174 50.9029C125.545 45.0391 128.98 38.9968 135.015 38.2146C138.016 37.8257 141.436 37.5391 145 37.5391C148.564 37.5391 151.985 37.8257 154.985 38.2146C161.021 38.9968 164.455 45.0391 162.826 50.9029L158.846 65.2314",
    stroke: "#EA4C54",
    strokeWidth: 8.30769
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145 54.1543C159.529 54.1543 171.308 65.9326 171.308 80.4619C171.308 88.2213 167.948 95.1952 162.604 100.01C161.688 100.835 160.477 101.231 159.245 101.231H130.755C129.523 101.231 128.312 100.835 127.396 100.01C122.052 95.1952 118.692 88.2213 118.692 80.4619C118.692 65.9326 130.471 54.1543 145 54.1543Z",
    fill: "#EA4C54"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 79.0769,
    r: 11.0769,
    fill: "#DA4149"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.077 64.6157L219.212 47.1031C217.221 39.9363 221.419 32.5512 228.796 31.5952C232.463 31.1199 236.644 30.7695 241 30.7695C245.356 30.7695 249.537 31.1199 253.204 31.5952C260.58 32.5512 264.778 39.9363 262.788 47.1031L257.923 64.6157",
    stroke: "#EA4C54",
    strokeWidth: 10.1538
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241 51.0762C258.758 51.0764 273.154 65.4725 273.154 83.2305C273.154 92.7135 269.048 101.237 262.517 107.121C261.398 108.13 259.918 108.614 258.411 108.614H223.589C222.082 108.614 220.602 108.13 219.483 107.121C212.952 101.237 208.846 92.7134 208.846 83.2305C208.846 65.4724 223.242 51.0762 241 51.0762Z",
    fill: "#EA4C54"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 81.5385,
    r: 13.5385,
    fill: "#DA4149"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 82,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.5 98L173.5 102L180.5 94",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 82,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 98L77.5 102L84.5 94",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 82,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 98,
    r: 2,
    fill: "#24284E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 98,
    r: 2,
    fill: "#24284E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 98,
    r: 2,
    fill: "#24284E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 122,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 30,
    r: 2,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 120.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 31.5,
    r: 1.5,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 140.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.5,
    cy: 117.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.5,
    cy: 142.5,
    r: 1.5,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.5,
    cy: 47.5,
    r: 1.5,
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.5,
    cy: 47.5,
    r: 1.5,
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197 13L206 24",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M281 3L270 19",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M252 126L258 142",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceStrengthTraining);
export default __webpack_public_path__ + "static/media/persistence-strength-training.42b09ffb31583846e52b97f66a3188e3.svg";
export { ForwardRef as ReactComponent };